import { render } from "./TheFooter.vue?vue&type=template&id=ad2b929e&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=ad2b929e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\estimate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad2b929e"]])

export default __exports__